import { render, staticRenderFns } from "./CommitteeChairmanAgenda.vue?vue&type=template&id=ffa3aa74&scoped=true"
import script from "./CommitteeChairmanAgenda.vue?vue&type=script&lang=js"
export * from "./CommitteeChairmanAgenda.vue?vue&type=script&lang=js"
import style0 from "./CommitteeChairmanAgenda.vue?vue&type=style&index=0&id=ffa3aa74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffa3aa74",
  null
  
)

export default component.exports